import React, {useRef, useState} from "react";
import { Message } from "primereact/message";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import axios from "axios";
import qs from "qs";
import {Toast} from "primereact/toast";

export const PayGateCheckout = ({amount, cancelTopup, currency, allowCheckout}) => {
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const userAuth = useSelector(state => state.userAuth);
    const mopriSettings = useSelector(state => state.mopriSettings);
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);
    const myToast = useRef(null);


    const handlePayGatePayment = async () => {
        // Start the Process.  Save the transaction and get the payment request ID.
        await axios({
            method: 'post',
            url: `${apiURL}/api/gateway/payGatePayment`,
            data: qs.stringify({
                value: amount,
                uid: userAuth.mopriUID,
                email: userAuth.email,
                currencyCode: mopriSettings.internationalSettings.localizationCountry,
                baseURL: window.location.origin
            }),
            config: { headers: {'Content-Type': 'application/x-www-form-urlencoded' }}
        })
            .then((response) => {
                if (response && response.data.error) {
                    myToast.current.show({severity: 'error', summary: 'ERROR', detail: response.data.errorMessage, life: 5000});
                } else {
                    myToast.current.show({severity: 'success', summary: 'Success', detail: 'You will be redirected to PayGate to complete the topup.', life: 5000});
                    redirectToPayGate(response.data.payGateResponse)
                }
                setSubmitButtonDisabled(false)
            })
            .catch((e) => {
                myToast.current.show({severity: 'error', summary: 'ERROR', detail: 'An unspecified error took place while attempting to do the PayGate checkout..', life: 5000});
                setSubmitButtonDisabled(false)
                console.log(e);
            });
    }

    const redirectToPayGate = (payGateResponse) => {
        const form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', 'https://secure.paygate.co.za/payweb3/process.trans');

        const input1 = document.createElement('input');
        input1.setAttribute('name', 'PAY_REQUEST_ID');
        input1.setAttribute('value', payGateResponse.PAY_REQUEST_ID);
        input1.setAttribute('hidden', true);

        const input2 = document.createElement('input');
        input2.setAttribute('name', 'CHECKSUM');
        input2.setAttribute('value', payGateResponse.CHECKSUM);
        input2.setAttribute('hidden', true);

        form.appendChild(input1);
        form.appendChild(input2);

        document.body.appendChild(form);

        form.submit();
    }

    return (
        <div className="grid" style={{paddingBottom: '20px'}}>
            <Toast ref={myToast}/>
            <div className="col-6">
                <div className="flex align-items-center">
                    <img
                        src="img/payGate.png"
                        alt={"PayGate"}
                        style={{
                            height: '80px',
                            width: 'auto',
                        }}
                    />
                </div>
            </div>
            <div className="col-6" style={{paddingTop: '20px'}}>
                <div className="p-fluid grid">
                    <div className="field col-6">
                        {allowCheckout &&
                            <Button label="Cancel"
                                    severity="danger" type="button"
                                    disabled={submitButtonDisabled}
                                    onClick={() => cancelTopup()}
                            />
                        }
                    </div>
                    <div className="field col-6">
                        <Button label={`Checkout ${amount ? `(${currency}${amount})` : ''}`}
                                severity="success"
                                disabled={submitButtonDisabled|| !allowCheckout}
                                onClick={() => handlePayGatePayment()}
                        />
                    </div>
                </div>
            </div>


            {submitButtonDisabled &&
                <div className="col-12">
                    <Message severity="success" text="Please wait, you are about to be redirected to PayGate to complete the topup." className="w-full justify-content-start" />
                </div>
            }
        </div>
    )
}